export interface ImageInfo {
  images: Image;
  filename: string;
}

export enum Status {
  init = 'init',
  loading = 'loading',
}
interface Image {
  original: string;
  thumbnail: string;
  medium: string;
  large: string;
}
